import React, { useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Button from "../component/button";
import { Tooltip, IconButton } from "@mui/material";
import { withTranslation } from "react-i18next";

const ScrollToTopButton = (props) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
               in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <React.Fragment>
      {visible && (
        <Tooltip title={props.t("SCROLL_TO_TOP")}>
          <div
            onClick={scrollToTop}
            className={"scrolllToTopIcon scrolllToTopButton"}
          >
            <ExpandLessIcon />
          </div>
        </Tooltip>
      )}
    </React.Fragment>
  );
};
export default withTranslation("translations")(ScrollToTopButton);
// export default ScrollToTopButton;
